module.exports = [{"id":"1","form":"atendente","title":"Atendente","description":"","btnText":"Selecionar"},{"id":"2","form":"uniforme","title":"Uniforme","description":"","btnText":"Selecionar"},{"id":"3","form":"recebido","title":"Dados do Recebedor","description":"","btnText":"Selecionar"}]


//////////////////
// WEBPACK FOOTER
// ./src/fixtures/adminUniforms.json
// module id = 1303
// module chunks = 0